export const LIST_REGULATION = 'LIST_REGULATION';
export const LIST_REGULATION_SUCCESS = `${LIST_REGULATION}_SUCCESS`;
export const LIST_REGULATION_FAIL = `${LIST_REGULATION}_FAIL`;

const initialState = {
  value: [],
  isLoading: false,
  finishRequests: false,
  isError: false,
  error: null,
  campaignId: null,
  vendorId: null,
  regulationType: null,
  catalogId: null,
};

/* eslint-disable */
const RegulationReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case LIST_REGULATION: {
      return {
        ...state,
        isLoading: true,
        finishRequest: false,
        isError: false,
        campaignId: action.payload.campaignId,
        vendorId: action.payload.vendorId,
        regulationType: action.payload.regulationType,
        catalogId: action.payload.catalogId,
      };
    }
    case LIST_REGULATION_SUCCESS: {
      const { campaignId, catalogId, vendorId, regulationType } = state;
      const index = `${campaignId || '-'}${catalogId || '-'}${vendorId || '-'}${
        regulationType || '-'
      }`;

      return {
        ...state,
        isLoading: false,
        finishRequest: false,
        isError: false,
        value: {
          ...state.value,
          [index]: { result: action.payload.data },
        },
      };
    }
    case LIST_REGULATION_FAIL: {
      const { campaignId, catalogId, vendorId, regulationType } = state;
      const index = `${campaignId || '-'}${catalogId || '-'}${vendorId || '-'}${
        regulationType || '-'
      }`;
      return {
        ...state,
        isLoading: false,
        finishRequest: false,
        isError: true,
        value: {
          ...state.value,
          [index]: { result: null },
        },
        error: action.error,
      };
    }
    default:
      return state || initialState;
  }
};

export default RegulationReducer;
